import flag from "../../../assets/imgs/gh.svg";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import quick_models from "../../../network/models/quick_models";
import merchant from "../../../network/services/merchant";
import {getCourierBusinessId} from "../../../helpers/authenticator";
import Loader from "react-loaders";

const Business = () => {
    const {register, handleSubmit, watch, errors} = useForm();
    const [business, setBusiness] = useState();
    const [isLoading, setIsLoading] = useState(true);

    let businessState = {...quick_models.businessInfoResponse, ...business};


    useEffect(() => {
        merchant.getBusinessInfo(getCourierBusinessId()).then(response => {
                setBusiness(response.data.data);
                setIsLoading(false);
            }
        ).catch(error => {
            setIsLoading(false);
        });
    }, []);


    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    {
                        isLoading ? <Loader type="ball-scale-multiple"/> : <div className="col-md-7">
                            <form onSubmit={handleSubmit}>
                                <ul className="list-unstyled">
                                    <li>
                                        <small className="small-text-grey">Business name</small>
                                    </li>
                                    <li style={{marginTop: 15}}>
                                        <div className="input-group">
                                            <input type="text"
                                                   className="form-control form-control-lg input-form-alt"
                                                   placeholder="Your business name"
                                                   onChange={() => {
                                                   }}
                                                   value={businessState.name}
                                                   aria-label="Username" aria-describedby="basic-addon1"/>
                                        </div>
                                    </li>

                                    <li>
                                        <small className="small-text-grey">Address</small>
                                    </li>
                                    <li style={{marginTop: 15}}>
                                        <div className="input-group">
                                            <input type="text"
                                                   className="form-control form-control-lg input-form-alt"
                                                   placeholder="Your address"
                                                   onChange={() => {
                                                   }}
                                                   value={businessState.address}
                                                   aria-label="Username" aria-describedby="basic-addon1"/>
                                        </div>
                                    </li>

                                    <li>
                                        <small className="small-text-grey">Contact Number</small>
                                    </li>
                                    <li style={{marginTop: 15}}>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">
                                            <img style={{height: 14, marginRight: 5}} src={flag}
                                                 className="img-fluid"/> +233
                                    </span>
                                            </div>
                                            <input type="text" className="form-control form-control-lg input-form"
                                                   placeholder="Enter your phone number"
                                                   maxLength="10"
                                                   name="phone"
                                                   value={businessState.phone}
                                                   onChange={() => {
                                                   }}
                                                   aria-label="Username" aria-describedby="basic-addon1"/>
                                        </div>
                                    </li>

                                    <li>
                                        <small className="small-text-grey">Website</small>
                                    </li>
                                    <li style={{marginTop: 15}}>
                                        <div className="input-group">
                                            <input type="text"
                                                   className="form-control form-control-lg input-form-alt"
                                                   placeholder="eg. example.com"
                                                   onChange={() => {
                                                   }}
                                                   value={businessState.email}
                                                   aria-label="Username" aria-describedby="basic-addon1"/>
                                        </div>
                                    </li>

                                    <p className="text-left small-text-blue text-right">
                                        Save >>
                                    </p>
                                </ul>
                            </form>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default Business;
